import { render, staticRenderFns } from "./survey_questions.vue?vue&type=template&id=59dc02d8&scoped=true"
import script from "./survey_questions.vue?vue&type=script&lang=ts"
export * from "./survey_questions.vue?vue&type=script&lang=ts"
import style0 from "./survey_questions.vue?vue&type=style&index=0&id=59dc02d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dc02d8",
  null
  
)

export default component.exports